import { stage } from './stage';

/**
 * Async API config — where the web console reaches the Lambda-backed HTTP API
 * (session restore/CRUD today; jobs/workflows live on the same surface).
 *
 * This is the SAME custom domain as the agent streaming endpoint but a
 * DIFFERENT backend: `OmApiGateway{Stage}` root-maps the async HTTP API (v2)
 * under the domain, while `/agents` is a separate base-path mapping to the
 * streaming REST gateway. Session routes therefore live at
 * `/agent-sessions/...` — a distinct first path segment that falls through to
 * the root-mapped async API. Do NOT reuse `agentConfig.invokeUrl` (it points at
 * `/agents`, a different integration). Auth is the same Cognito access-token
 * bearer (`getAccessToken`).
 *
 * `VITE_ASYNC_API_URL` overrides the origin at build time (CI / local against a
 * raw execute-api URL). `prod-never-calls-beta`: the prod branch resolves only
 * the prod origin; the beta default is never referenced from it.
 */
export interface AsyncApiConfig {
  /** Origin of the async HTTP API, e.g. `https://api-beta.oculusmind.ai`. */
  readonly baseUrl: string;
}

const BETA_BASE = 'https://api-beta.oculusmind.ai';
const PROD_BASE = 'https://api.oculusmind.ai';

function buildConfig(s: 'local' | 'beta' | 'prod'): AsyncApiConfig {
  const base =
    s === 'prod'
      ? import.meta.env.VITE_ASYNC_API_URL || PROD_BASE
      : import.meta.env.VITE_ASYNC_API_URL || BETA_BASE;
  return { baseUrl: base };
}

export const asyncApiConfig: AsyncApiConfig = buildConfig(stage);
